import { ChipInfoStatusEnum } from "components/Status/ChipInfo/chipInfo.interface"

export enum StatusIssueReportEnum {
  None = 0,
  New = 1,
  Planned = 2,
  Booked = 3,
  Resolved = 4,
  Completed = 5
}

export const issueReportChip = (type: StatusIssueReportEnum): ChipInfoStatusEnum => {
  switch (type) {
    case StatusIssueReportEnum.None:
      return ChipInfoStatusEnum.None
    case StatusIssueReportEnum.New:
      return ChipInfoStatusEnum.New
    case StatusIssueReportEnum.Planned:
      return ChipInfoStatusEnum.Planned
    case StatusIssueReportEnum.Booked:
      return ChipInfoStatusEnum.Booked
    case StatusIssueReportEnum.Resolved:
      return ChipInfoStatusEnum.Resolved
    case StatusIssueReportEnum.Completed:
      return ChipInfoStatusEnum.Completed
    default:
      return ChipInfoStatusEnum.New
  }
}
